import { ACCOUNT_LIST,ACCOUNT_MESSAGE,ACCOUNT_REGISTER_SUCCESS,UNAUTHERIZE_MESSAGE,DEFAULT_ACCOUNT,SHOW_LOADING,HIDE_LOADING, ALL_ACCOUNT_LIST, GET_ACCOUNT_LIST, GET_DEFAULT_ACCOUNT } from "redux/constants/account";
import { APP_PREFIX_PATH} from 'configs/AppConfig'

const initState = {
    loading : true,
    accountList : [],
    allAccountList:[],
    account:{},
    message: '',
    showMessage: false,
    redirect : "",
    allowRedirect:false,
    status:0,
    token:null,
    accountListLoaded: false
}

const account =(state=initState,action) =>{
    switch(action?.type){
        case GET_ACCOUNT_LIST:
        case GET_DEFAULT_ACCOUNT:
         return{
             ...state,
             loading: true,
             accountListLoaded: false,
             showMessage: false
         }
        case ACCOUNT_LIST:
         return{
             ...state,
             accountList : action?.accountList,
             allowRedirect :false,
             loading:false,
             accountListLoaded: true,
             message:""
         }
         case ALL_ACCOUNT_LIST:
         return{
             ...state,
             allAccountList : action?.allAccountList,
             allowRedirect :false,
             loading:false,
             message:""
         }
         case ACCOUNT_MESSAGE:
         return{
             ...state,
             message : messageRead(action),
             status:action?.response?.status,
             showMessage : true,
             loading: false,
             accountListLoaded: true,
             allowRedirect : false
         }
         case ACCOUNT_REGISTER_SUCCESS:
            return{
                ...state,
                message : messageRead(action),
                status:action?.response?.status,
                showMessage : true,
                loading: false,
                allowRedirect :true,
                redirect : `${APP_PREFIX_PATH}/pages/account-list?mode=view-all`
            }
         case SHOW_LOADING: {
			return {
				...state,
				loading: true
			}
		}
        case HIDE_LOADING:{
			return{
				...state,
				loading:false
			}
		}
         default:
           return state;
    }
}

const messageRead=(action)=>{
    if(action?.response?.status===401 || action?.response?.response?.status){
        return "Unauthorized"
    }
	if(action?.response && action?.response?.response && action?.response?.response?.data && action?.response?.response?.message){
	 return action?.response?.response?.data?.message;
	}else if(action?.response && action?.response?.data && action?.response?.data?.message){
		return action?.response?.data?.message;
	}else if(action?.response && action?.response?.data && action?.response?.data?.message){
		return action?.response?.data?.message;
	}else if(action?.data?.message){
		return action?.data?.message;
	}else if(action?.data){
		return action?.data;
	}else{
		return "something went wrong"
	}
}

export default account;